import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectItem } from 'primeng/api';
import { SelectButtonChangeEvent } from 'primeng/selectbutton';
import { Artist, ArtistsService } from 'src/app/Services/artists.service';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';
import { ArtistOverlayDashboardResponse } from 'src/app/models/response/artistoverlaydashboard.model';

@Component({
    selector: 'artist-overlay',
    templateUrl: './artist-overlay.component.html',
    styleUrls: ['./artist-overlay.component.css'],
    inputs: ['visible', 'artistId'],
    outputs: ['onClosed'],
    standalone: false
})
export class ArtistOverlayComponent implements OnInit {
  // Public property to control overlay visibility
  public visible: boolean = false;
  @Input() showSalesHistory: boolean = true;
  public artistId: string | undefined = undefined;
  public onClosed = new EventEmitter<void>();
  public artist: Artist = {} as Artist;
  // Public property to store dashboard data
  public dashboardData: ArtistOverlayDashboardResponse = {};
  public dashboardDataLoaded: boolean = false;
  public authConfig: AuthConfig = {};
  // Public property to store artist address
  public artistAddress: string = '';
  // Public property to track selected tab index
  public selectedTabIndex: number = 0;

  // Options for sorting high-performing artworks
  public highPerformArtworksSortOptions: SelectItem[] = [
    { label: 'By Revenue', value: 'ByRevenue' },
    { label: 'By Series', value: 'BySeries', disabled: true },
    { label: 'By Turnover', value: 'ByTurnover', disabled: true }
  ];

  // Default sort option for high-performing artworks
  public selectedHighPerformArtworksSortOption: string = 'ByRevenue';

  // Constructor with dependency injection
  constructor(
    private authService: AuthService, // Service for authentication
    private ngxSpinnerService: NgxSpinnerService, // Service for loading spinner
    private artistsService: ArtistsService // Service for artist-related operations
  ) { }

  // Lifecycle hook to initialize component
  public ngOnInit(): void {
    // Retrieve authentication configuration
    this.authConfig = this.authService.getAuthConfig();

    // Fetch artist details and overlay panel highlights if artistId is provided
    if (this.artistId) {
      this.getArtistDetails(this.artistId);
      this.getArtistOverlayPanelHighlights(this.artistId);
    }
  }

  // Handler for sort option selection change
  public onHighPerformArtworksSortOptionSelected($event: any) {
    console.log($event); // Log the event for debugging
    // Note: Use $event.value to access the selected value if needed
  }

  // Private method to fetch artist details by ID
  private getArtistDetails(artistId: string) {
    this.ngxSpinnerService.show(); // Show loading spinner
    this.artistsService.getArtistById(artistId).subscribe(
      (artist: Artist) => {
        this.artist = artist; // Assign fetched artist data
        console.log('artist-Detail', this.artist); // Log artist details for debugging
        this.ngxSpinnerService.hide(); // Hide loading spinner
      },
      (error) => {
        console.error('Error fetching the logged-in user: ', error); // Log error
        this.ngxSpinnerService.hide(); // Hide loading spinner on error
      }
    );
  }

  // Method to fetch artist overlay panel highlights
  public getArtistOverlayPanelHighlights(artistId: string) {
    this.artistsService.getArtistOverlayPanelHighlights(artistId).subscribe(
      (data: ArtistOverlayDashboardResponse) => {
        // Process best-selling series data
        data.ArtistBestSellingSeries?.forEach((item) => {
          // Set color class and text based on percentage
          var colorClass = this.getColorBasedOnPercentage(item.PercentageOfTotal);
          item.ColorClassBasedOnPercentage = 'bg-' + colorClass;
          item.TextBasedOnPercentage = `<span class="text-${colorClass}">${item.PercentageOfTotal}%</span>`;
        });
        console.log(data); // Log dashboard data for debugging
        this.dashboardData = data; // Assign fetched dashboard data
        this.dashboardDataLoaded = true; // Set data loaded flag
      },
      (error) => {
        console.error(error); // Log error
      }
    );
  }

  // Private method to determine color class based on percentage
  private getColorBasedOnPercentage(percentage: number): string {
    if (percentage >= 75) {
      return 'success'; // High percentage
    } else if (percentage >= 50) {
      return 'info'; // Medium-high percentage
    } else if (percentage >= 25) {
      return 'warning'; // Medium-low percentage
    }
    return 'danger'; // Low percentage
  }

  // Method to handle overlay close event
  public onClose($event: any) {
    this.onClosed.emit(); // Emit close event
  }
}